import Vue from "vue";
import Router from "vue-router";
import guard from "./javascript/navigation-guard";

import LoginPage from "./views/Auth/Login.vue";

import HomePage from "./views/Home/Home.vue";
import InteractionMenu from "./views/Interaction/InteractionMenu.vue";
import AcademyMenu from "./views/Academy/AcademyHome.vue";
import ChatHome from "./views/Chat/ChatHome.vue";
import NotificationHome from "./views/Notification/NotificationHome.vue";
import MyProfile from "./views/Profile/MyProfile.vue";
import OtherProfile from "./views/Profile/OtherProfile.vue";

//Search
import SearchHome from "./views/Search/SearchHome.vue";

//Bat News
import BatNews from "./views/BatNews/BatNews.vue";

//Interaction
import BestOfUsers from "./views/Interaction/BestOfUsers.vue";
import ThanksForm from "./views/Interaction/ThanksForm.vue";
import SurveyList from "./views/Interaction/SurveyList.vue";
import SurveyDetail from "./views/Interaction/SurveyDetail.vue";
import NewComers from "./views/Interaction/NewComers.vue";
import BornTodayUsers from "./views/Interaction/BornTodayUsers.vue";
import WhosWho from "./views/Interaction/WhosWho.vue";
import Adverts from "./views/Interaction/Adverts.vue";
import AdvertDetail from "./views/Interaction/AdvertDetail.vue";
import OtherApplication from "./views/Interaction/OtherApplication.vue";

//Live Stream
import LiveStreamArchive from "./views/LiveStream/LiveStreamArchive.vue";
import LiveStreamRequest from "./views/LiveStream/LiveStreamRequest.vue";
import LiveStream from "./views/LiveStream/LiveStream.vue";
import JoinLiveStream from "./views/LiveStream/JoinLiveStream.vue";

//Bat News
import AcademySearch from "./views/Academy/AcademySearch.vue";
import AcademyCategories from "./views/Academy/AcademyCategories.vue";
import AcademySubCategories from "./views/Academy/AcademySubCategories.vue";

//Posts
import PostDetail from "./views/Post/PostDetail.vue";

//Custom Emoji
import CustomEmoji from "./views/Home/CustomEmoji.vue";

//WheelScreen
import WheelScreen from "./views/Wheel/WheelScreen.vue";
import VizgoCategoryScreen from "./views/Vizgo/Categories.vue";
import VizgoCategoryDetail from "./views/Vizgo/CategoryDetail.vue";
import Training from "./views/Vizgo/Training.vue";
import Certificates from "./views/Vizgo/Certificates.vue";
import ChildSafetyPolicy from "./views/ChildSafetyPolicy.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    
    {
      path: "/login",
      name: "login",
      component: LoginPage,
      beforeEnter: guard.ifNotAuthenticated,
    },
    {
      path: "/child-safety-policy",
      name: 'childSafetyPolicy',
      component: ChildSafetyPolicy,
      beforeEnter: guard.ifNotAuthenticated,
    },
    {
      path: "/home",
      name: "home",
      component: HomePage,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/interaction",
      name: "interaction",
      component: InteractionMenu,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/academy",
      name: "academy",
      component: AcademyMenu,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/vizgoCategoryScreen",
      name: "vizgoCategoryScreen",
      component: VizgoCategoryScreen,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/vizgoCategoryDetail/:id",
      name: "vizgoCategoryDetail",
      component: VizgoCategoryDetail,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/training/",
      name: "training",
      component: Training,
      props: true,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/academySearch",
      name: "academySearch",
      component: AcademySearch,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/academyCategories",
      name: "academyCategories",
      component: AcademyCategories,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/academySubCategories/:id",
      name: "academySubCategories",
      component: AcademySubCategories,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/certificates",
      name: "certificates",
      component: Certificates,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/batNews",
      name: "batNews",
      component: BatNews,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/chat",
      name: "chat",
      component: ChatHome,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/notifications",
      name: "notifications",
      component: NotificationHome,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/myProfile",
      name: "myProfile",
      component: MyProfile,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/otherProfile/:id",
      name: "otherProfile",
      component: OtherProfile,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/searchHome",
      name: "searchHome",
      component: SearchHome,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/newComers",
      name: "newComers",
      component: NewComers,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/bornTodayUsers",
      name: "bornTodayUsers",
      component: BornTodayUsers,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/bestOfUsers",
      name: "bestOfUsers",
      component: BestOfUsers,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/whosWho",
      name: "whosWho",
      component: WhosWho,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/thanksForm",
      name: "thanksForm",
      component: ThanksForm,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/surveyList",
      name: "surveyList",
      component: SurveyList,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/postDetail/:id",
      name: "postDetail",
      component: PostDetail,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/surveyDetail/:id",
      name: "surveyDetail",
      component: SurveyDetail,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/customEmoji",
      name: "customEmoji",
      component: CustomEmoji,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/liveStreamArchive",
      name: "liveStreamArchive",
      component: LiveStreamArchive,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/liveStreamRequest",
      name: "liveStreamRequest",
      component: LiveStreamRequest,
      beforeEnter: guard.ifAuthenticated, //&& guard.isAdmin
      //TODO: Burada sayfa direk açılınca token düşüyor buna bakılacak
    },
    {
      path: "/liveStream",
      name: "liveStream",
      component: LiveStream,
      beforeEnter: guard.ifAuthenticated, //&& guard.isAdmin
      //TODO: Burada sayfa direk açılınca token düşüyor buna bakılacak
    },
    {
      path: "/joinLiveStream/:id",
      name: "joinLiveStream",
      component: JoinLiveStream,
      beforeEnter: guard.ifAuthenticated, //&& guard.isAdmin
      //TODO: Burada sayfa direk açılınca token düşüyor buna bakılacak
    },
    {
      path: "/adverts",
      name: "adverts",
      component: Adverts,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/advertDetail/:id",
      name: "advertDetail",
      component: AdvertDetail,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/otherApplication",
      name: "otherApplication",
      component: OtherApplication,
      beforeEnter: guard.ifAuthenticated,
    },
    {
      path: "/wheelscreen",
      name: "wheelscreen",
      component: WheelScreen,
      beforeEnter: guard.ifAuthenticated,
    },
  ],
});
